<div *ngIf="isEditMode; else readModeBlock" class="edit-mode">
  <form [formGroup]="editForm">
    <span matLine class="label">{{ label }}</span>
    <div class="button-container">
      <button
        mat-flat-button
        color="primary"
        (click)="onSaveClicked()"
        [disabled]="!(editForm.valid && editForm.dirty)"
      >
        <mat-icon class="md-18">check</mat-icon> Save
      </button>
      <button type="button" mat-stroked-button (click)="toggleEditMode(false)">
        <mat-icon class="md-18">close</mat-icon> Cancel
      </button>
    </div>
    <div class="value-description" matLine>
      <rich-text-editor [form]="editForm" field="description" [getFocusWhenStart]="true"></rich-text-editor>
    </div>
  </form>
</div>

<ng-template #readModeBlock>
  <div class="read-mode">
    <span matLine class="label">{{ label }}</span>
    <div class="value-description" matLine [innerHTML]="description | safeHtml"></div>
    <div class="button-container">
      <button mat-stroked-button (click)="toggleEditMode(true)"><mat-icon class="md-18">edit</mat-icon> edit</button>
    </div>
  </div>
</ng-template>
